import Modal from '@/components/Modal'
import { PRE_SCHEDULE_CONFIRMATION_CARD_MODAL_ID } from './CancelPreScheduleConfirmationModal.constants'
import { Flex, getTheme, Text } from '@conexasaude/conexa-hero'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { CancelPreScheduleConfirmationModalProps } from './CancelPreScheduleConfirmationModal.types'
import { useCancelPreScheduleConfirmationModal } from './CancelPreScheduleConfirmationModal.hook'

export const CancelPreScheduleConfirmationModal = (
  props: CancelPreScheduleConfirmationModalProps,
) => {
  const {
    data: { professionalName },
  } = props
  const theme = getTheme()
  const { closeModal } = useModalContext()
  const { data, actions, loadings } =
    useCancelPreScheduleConfirmationModal(props)

  return (
    <Modal
      id={PRE_SCHEDULE_CONFIRMATION_CARD_MODAL_ID}
      primaryActionLabel="Cancelar"
      negativeActionLabel="Agora não"
      negativeAction={closeModal}
      primaryAction={actions.handlePrimaryAction}
      busyPrimaryAction={loadings.primaryAction}
    >
      <Flex my={theme.spacing.sm}>
        <Text variant="paragraphLarge" color={theme.colors.neutral[400]}>
          Ao cancelar, o horário do dia{' '}
          <Text renderAs="span" fontWeight={600}>
            {data.preScheduleFormatted?.date} as{' '}
            {data.preScheduleFormatted?.time} com {professionalName} será
            cancelado
          </Text>{' '}
          e ficará disponível para outros pacientes.
        </Text>
      </Flex>
    </Modal>
  )
}
